import { render } from "./UploadStepMedia.vue?vue&type=template&id=0ab19540"
import script from "./UploadStepMedia.vue?vue&type=script&lang=js"
export * from "./UploadStepMedia.vue?vue&type=script&lang=js"

import "./UploadStepMedia.vue?vue&type=style&index=0&id=0ab19540&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__